import React from 'react';
import PropTypes from 'prop-types';
/* components */
import NavLink from 'components/nav-link/nav-link';
import ScrollArea from 'components/scroll-area/scroll-area';
/* assets */
import logoSrc from '../../../assets/images/orbitmi_logo.svg';
/* styles */
import './nav-menu.scss';

export class NavMenu extends React.PureComponent {
    goToAccount = this.props.setActiveLink.bind(this, 'account');

    removeActiveLink = () => {
        if (this.props.activeLinkName) {
            this.props.setActiveLink();
        }
    };

    render() {
        if (!this.props.setActiveLink) {
            return null;
        }

        const navClassNames = `sten-nav-menu${this.props.isExpanded ? ' sten-nav-menu--expanded' : ''}`;

        return (
            <nav className={navClassNames}>
                <div className="sten-nav-menu__container sten-nav-menu__container--top">
                    <ScrollArea horizontal={false}>
                        <NavLink
                            hasContentLink
                            onClick={this.props.toggleExpand}
                            to="/"
                            icon="menu"
                            isActive={this.props.isExpanded}
                            tooltipTitle={!this.props.isExpanded ? 'Expand' : ''}
                        >
                            <img className="sten-nav-menu__logo" src={logoSrc} alt="OrbitMI" />
                        </NavLink>
                        <NavLink
                            onClick={this.removeActiveLink}
                            to="/"
                            isActive={this.props.pathName.toLowerCase() === '/'}
                            icon="tenant"
                            tooltipTitle={!this.props.isExpanded ? 'Tenant Information' : ''}
                        >
                            Tenant information
                        </NavLink>
                        <NavLink
                            onClick={this.removeActiveLink}
                            to="/clients"
                            isActive={this.props.pathName.toLowerCase().startsWith('/clients')}
                            icon="client"
                            tooltipTitle={!this.props.isExpanded ? 'Clients' : ''}
                        >
                            Clients
                        </NavLink>
                        <NavLink
                            onClick={this.removeActiveLink}
                            to="/schemes"
                            isActive={this.props.pathName.toLowerCase().startsWith('/schemes')}
                            icon="scheme"
                            tooltipTitle={!this.props.isExpanded ? 'Auth Schemes' : ''}
                        >
                            Auth Schemes
                        </NavLink>
                        <NavLink
                            onClick={this.removeActiveLink}
                            to="/scopes"
                            isActive={this.props.pathName.toLowerCase().startsWith('/scopes')}
                            icon="scope"
                            tooltipTitle={!this.props.isExpanded ? 'Scopes' : ''}
                        >
                            Scopes
                        </NavLink>
                        <NavLink
                            onClick={this.removeActiveLink}
                            to="/systemUsers"
                            isActive={this.props.pathName.toLowerCase().startsWith('/systemusers')}
                            icon="users"
                            tooltipTitle={!this.props.isExpanded ? 'System Users' : ''}
                        >
                            System Users
                        </NavLink>
                        <div className="sten-nav-menu__bottom-button-container">
                            <NavLink
                                onClick={this.goToAccount}
                                icon="account"
                                isActive={this.props.activeLinkName === 'account'}
                                tooltipTitle={!this.props.isExpanded ? 'Account' : ''}
                            >
                                Account
                            </NavLink>
                        </div>
                    </ScrollArea>
                </div>
                <div className="sten-nav-menu__container sten-nav-menu__container--bottom">
                    <NavLink
                        onClick={this.goToAccount}
                        icon="account"
                        isActive={this.props.activeLinkName === 'account'}
                        tooltipTitle={!this.props.isExpanded ? 'Account' : ''}
                    >
                        Account
                    </NavLink>
                </div>
            </nav>
        );
    }
}

NavMenu.propTypes = {
    activeLinkName: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    setActiveLink: PropTypes.func.isRequired,
    name: PropTypes.string,
    pathName: PropTypes.string,
    toggleExpand: PropTypes.func.isRequired
};

NavMenu.defaultProps = {
    name: '',
    pathName: ''
};

export default NavMenu;
